import React from 'react';
import Modal from 'react-modal';
import { useForm } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { T, useTranslate } from 'shared/helper/translate';
import { validators } from 'shared/helper/form';
import { OTP_LENGTH, CHINA_COUNTRY_CODE } from '../constants';
import useOtpFlow from './useOtpFlow';
var chinesePhoneRequired = validators.chinesePhoneRequired,
  createChinesePhoneLengthValidator = validators.createChinesePhoneLengthValidator,
  createChinesePhoneNumbersOnlyValidator = validators.createChinesePhoneNumbersOnlyValidator;
var RubriqChinaOtpModal = function RubriqChinaOtpModal(_ref) {
  var open = _ref.open,
    phoneNumber = _ref.phoneNumber,
    sendOtp = _ref.sendOtp,
    verifyOtp = _ref.verifyOtp,
    onClose = _ref.onClose;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var methods = useForm({
    mode: 'onChange'
  });
  var register = methods.register,
    watch = methods.watch,
    errors = methods.formState.errors;
  var countryCode = CHINA_COUNTRY_CODE;
  var _useOtpFlow = useOtpFlow({
      phoneNumber: phoneNumber,
      sendOtp: sendOtp,
      verifyOtp: verifyOtp,
      open: open,
      onClose: onClose,
      methods: methods
    }),
    step = _useOtpFlow.step,
    otp = _useOtpFlow.otp,
    setOtp = _useOtpFlow.setOtp,
    cooldown = _useOtpFlow.cooldown,
    isSendingOtp = _useOtpFlow.isSendingOtp,
    isVerifying = _useOtpFlow.isVerifying,
    localPhone = _useOtpFlow.localPhone,
    setLocalPhone = _useOtpFlow.setLocalPhone,
    otpRefs = _useOtpFlow.otpRefs,
    handleSendOtp = _useOtpFlow.handleSendOtp,
    handleVerify = _useOtpFlow.handleVerify,
    handleResend = _useOtpFlow.handleResend,
    handleChange = _useOtpFlow.handleChange,
    isResendingOtp = _useOtpFlow.isResendingOtp,
    setStep = _useOtpFlow.setStep;
  var watchedPhone = watch('phoneNumber');
  var isPhoneValid = !!watchedPhone && !errors.phoneNumber;
  if (!open) return null;
  var phoneRegister = register('phoneNumber', {
    validate: {
      chinesePhoneRequired: chinesePhoneRequired(countryCode === null || countryCode === void 0 ? void 0 : countryCode.value),
      chinesePhoneLength: createChinesePhoneLengthValidator(countryCode === null || countryCode === void 0 ? void 0 : countryCode.value),
      chinesePhoneNumbersOnly: createChinesePhoneNumbersOnlyValidator(countryCode === null || countryCode === void 0 ? void 0 : countryCode.value)
    }
  });
  return /*#__PURE__*/React.createElement(Modal, {
    appElement: window.document.querySelector('#researcher-app'),
    className: "react-modal rubriq-otp-custom",
    overlayClassName: "react-modal-overlay",
    isOpen: true
  }, step !== 'success' && /*#__PURE__*/React.createElement("div", {
    className: "react-modal-header"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn-close",
    onClick: onClose
  }, /*#__PURE__*/React.createElement("span", null, "\xD7")), /*#__PURE__*/React.createElement("h1", {
    className: "react-modal-title"
  }, step === 'intro' && /*#__PURE__*/React.createElement(T, {
    source: "otp-verify-phone-title"
  }), step === 'verify' && /*#__PURE__*/React.createElement(T, {
    source: "otp-enter-code-title"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "react-modal-content"
  }, step === 'intro' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(T, {
    source: "otp-intro-message"
  })), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(T, {
    source: "otp-verify-later-message"
  }), ' ', /*#__PURE__*/React.createElement("a", {
    href: "/account",
    className: "trackable-link"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Account Settings"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "rubriq-phone-wrapper"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label phone-number-lable mt-3"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Mobile number"
  })), /*#__PURE__*/React.createElement("div", {
    className: "rubriq-phone-fields"
  }, /*#__PURE__*/React.createElement("input", {
    className: "form-control rubriq-country-code",
    value: countryCode === null || countryCode === void 0 ? void 0 : countryCode.value,
    readOnly: true
  }), /*#__PURE__*/React.createElement("input", {
    className: "form-control rubriq-phone-input ".concat(isSendingOtp ? 'disabled' : ''),
    value: localPhone,
    name: phoneRegister.name,
    placeholder: t('PHONE_NUMBER'),
    ref: phoneRegister.ref,
    maxLength: countryCode === null || countryCode === void 0 ? void 0 : countryCode.phoneLength,
    onBlur: phoneRegister.onBlur,
    disabled: isSendingOtp // disables input
    ,
    readOnly: isSendingOtp // prevents typing
    ,
    onChange: function onChange(e) {
      if (isSendingOtp) return;
      setLocalPhone(e.target.value);
      phoneRegister.onChange(e);
    }
  })), errors.phoneNumber && /*#__PURE__*/React.createElement("p", {
    className: "text-danger mt-1"
  }, errors.phoneNumber.type === 'chinesePhoneRequired' && /*#__PURE__*/React.createElement(T, {
    source: "contact-number-required"
  }), errors.phoneNumber.type === 'chinesePhoneLength' && /*#__PURE__*/React.createElement(T, {
    source: "contact-number-validation"
  }), errors.phoneNumber.type === 'chinesePhoneNumbersOnly' && /*#__PURE__*/React.createElement(T, {
    source: "contact-number-no-letters-validation"
  })))), step === 'verify' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(T, {
    source: "otp-code-sent-message"
  }), ' ', /*#__PURE__*/React.createElement("span", {
    className: "rubriq-phone-strong"
  }, countryCode === null || countryCode === void 0 ? void 0 : countryCode.value, " ", localPhone), /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "pen",
    className: "rubriq-edit-icon ms-2",
    onClick: function onClick() {
      methods.setValue('phoneNumber', localPhone);
      setLocalPhone(localPhone);
      setOtp('');
      setStep('intro');
    }
  })), /*#__PURE__*/React.createElement("label", {
    className: "rubriq-otp-label"
  }, /*#__PURE__*/React.createElement(T, {
    source: "verification-code"
  })), /*#__PURE__*/React.createElement("div", {
    className: "rubriq-otp-group d-flex justify-content-center mb-3"
  }, [0, 1, 2, 3, 4, 5].map(function (i) {
    return /*#__PURE__*/React.createElement("input", {
      key: i,
      ref: function ref(el) {
        otpRefs.current[i] = el;
      },
      className: "form-control text-center rubriq-otp-input ".concat(isVerifying ? 'disabled' : ''),
      style: {
        width: 50,
        height: 50
      },
      maxLength: 1,
      inputMode: "numeric",
      value: otp[i] || '',
      disabled: isVerifying // disable
      ,
      readOnly: isVerifying // block typing
      ,
      onChange: function onChange(e) {
        if (isVerifying) return;
        handleChange(e.target.value, i);
      }
      // backspace → previous box
      ,
      onKeyDown: function onKeyDown(e) {
        if (isVerifying) return;
        if (e.key === 'Backspace' && !otp[i]) {
          var _otpRefs$current;
          (_otpRefs$current = otpRefs.current[i - 1]) === null || _otpRefs$current === void 0 || _otpRefs$current.focus();
        }
      }
      // paste full OTP
      ,
      onPaste: function onPaste(e) {
        if (isVerifying) return;
        var paste = e.clipboardData.getData('text');
        if (!/^\d{6}$/.test(paste)) return;
        setOtp(paste);
        handleVerify(paste);
      }
    });
  })), cooldown ? /*#__PURE__*/React.createElement("div", {
    className: "rubriq-resend-text"
  }, /*#__PURE__*/React.createElement(T, {
    source: "otp-resend-in"
  }), " ", /*#__PURE__*/React.createElement("span", {
    className: "timer"
  }, cooldown, "s")) : /*#__PURE__*/React.createElement("div", {
    className: "rubriq-resend-wrapper"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-link p-0 rubriq-resend-btn",
    onClick: handleResend,
    disabled: isResendingOtp
  }, /*#__PURE__*/React.createElement(T, {
    source: "resend-code"
  })))), step === 'success' && /*#__PURE__*/React.createElement("div", {
    className: "rubriq-success-wrap text-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rubriq-success-icon"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "check"
  })), /*#__PURE__*/React.createElement("h2", {
    className: "rubriq-success-title"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Verification Successful!"
  })), /*#__PURE__*/React.createElement("p", {
    className: "rubriq-success-text"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Your phone number"
  }), ' ', /*#__PURE__*/React.createElement("span", {
    className: "rubriq-phone-strong"
  }, countryCode === null || countryCode === void 0 ? void 0 : countryCode.value, " ", localPhone), ' ', /*#__PURE__*/React.createElement(T, {
    source: "has been successfully verified"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "react-modal-footer"
  }, step === 'intro' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-primary rubriq-btn-loading",
    onClick: handleSendOtp,
    disabled: isSendingOtp || !isPhoneValid
  }, /*#__PURE__*/React.createElement(T, {
    source: "verify"
  }), isSendingOtp && /*#__PURE__*/React.createElement("span", {
    className: "rubriq-dot-loader me-2"
  }, /*#__PURE__*/React.createElement("span", null))), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-light",
    onClick: onClose
  }, /*#__PURE__*/React.createElement(T, {
    source: "otp-later-button"
  }))), step === 'verify' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-primary",
    disabled: otp.length !== OTP_LENGTH || isVerifying,
    onClick: handleVerify
  }, /*#__PURE__*/React.createElement(T, {
    source: "verify"
  }), isVerifying && /*#__PURE__*/React.createElement("span", {
    className: "rubriq-dot-loader ms-2"
  }, /*#__PURE__*/React.createElement("span", null))), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-light",
    onClick: onClose
  }, /*#__PURE__*/React.createElement(T, {
    source: "cancel"
  }))), step === 'success' && /*#__PURE__*/React.createElement("div", {
    className: "react-modal-footer success-footer"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-primary rubriq-success-btn",
    onClick: onClose
  }, /*#__PURE__*/React.createElement(T, {
    source: "continue"
  })))));
};
export default RubriqChinaOtpModal;